import React, { useState, useRef } from 'react';

// import DisplayPhoneInput from 'components/login/user/profile/DisplayPhoneInput';
import DisplayPhoneInput from '../profile/DisplayPhoneInput';
// import { supported_dial_code } from 'components/common/CountryCodes';
import { supported_dial_code } from '../../../components/common/CountryCodes';
import { RequestOpenAxios } from '../APIUtils';
import { WarningAlert } from 'src/components/tool/Alerts';
// import Alert from 'react-s-alert';
import { saveAuthentication, isAuthenticated, saveUserInfo, userInfo } from '../CookiesUtil';
import { phonesignup,getCurrentUser } from '../APIUtils';

import PropTypes from 'prop-types';


const PhoneSignupForm = (props) => {

	console.log(props);


	PhoneSignupForm.propTypes={
        modifyAccess:PropTypes.func,
		myUser:PropTypes.string,
		newPhone:PropTypes.string,
		cdc:PropTypes.string
	}
	

	let myUser = props.myUser
	let newPhone = props.newPhone
	let cdc = props.cdc;

	const [vsent, setVsent] = useState(false);
	const [playalert, setPlayalert] = useState(false);
	const [amsg, setAmsg] = useState("default");

	const buttonRef = useRef(null);
	const buttonRefs = useRef(null);


	const sendVerificationCode = (e) => {

		e.preventDefault();
		newPhone = document.getElementById("newPhone").value;
		var confirmPhone = document.getElementById("confirmPhone").value;
		let temp = document.getElementById("isoId").value;
		// iso['name'] = temp.substring(0, temp.indexOf('('));
		temp = temp.substring(temp.indexOf('(') + 1);
		// iso['code'] = temp.slice(0, -1);
		console.log("temp:",temp);



		if (newPhone !== confirmPhone) {
			setAmsg("confirm phone# does not match!");
			setPlayalert(true);

			return;
		}

		if (isNaN(newPhone)) {
			setAmsg("it is not a phone number!");
			setPlayalert(true);

			return;
		}

		if (newPhone < 9999) {
			setAmsg("Incomplete phone number");
			setPlayalert(true);
			return;
		}

		let tenDigitCountry = ['+1', '+86'];

		if (tenDigitCountry.indexOf("+"+cdc) !== -1 && newPhone < 999999999) {
			setAmsg("Incomplete phone number");
			setPlayalert(true);

			return;
		}

		// if (world_countries.indexOf(iso.code) === -1) {

		if (supported_dial_code.indexOf("+"+cdc) === -1) {

			setAmsg("Currently,Menuwin donot support the country code you selected: ", cdc);
			setPlayalert(true);
			return;
		}


		// need to use auth for new user, restricted only for already logined user
		const options = {
			url: '/auth/customer/requestcustomerphoneverification',
			method: 'POST',
			mode: 'no-cors',
			data: {
				// id:mIds.join(',')
				// isoName: iso.name,
				// isoCode: iso.code,
				phone: newPhone,
				cdc:cdc,
			}
		}

		buttonRefs.current.disabled = true;



		RequestOpenAxios(options).then(
			res => {
				console.log("res ", res);
				buttonRefs.current.disabled = false;

				if (res.data.success) {

					setVsent(true);
					setPlayalert(false);

				} else {
					setAmsg(res.data.message)
					setVsent(false);
					setPlayalert(true);
				}

			}
		)

		myUser.phone = newPhone;
		myUser.cdc = cdc;
		// myUser.iso = {
		// 	name: iso.name,
		// 	code: iso.code,
		// }
	}





	const submitVerification = (event) => {
		event.preventDefault();

		myUser.phoneRegistrationCode = document.getElementById("vcode").value;
		myUser.familyName = document.getElementById("firstName").value;
		myUser.givenName = document.getElementById("lastName").value;

		myUser.name=myUser.familyName+" "+myUser.givenName;
		// myUser.phone = document.getElementById("phone").value;
		myUser.password = document.getElementById("password").value;
		// myUser.email = document.getElementById("email").value;

		if (myUser.phoneRegistrationCode.length < 4) {
			setAmsg("please fill in the phone verification code");
			setPlayalert(true);
			return;
		}

		const signUpRequest = Object.assign({}, myUser);

		console.log("signUpRequest:", signUpRequest);

		buttonRef.current.disabled = true;

		phonesignup(signUpRequest).then(response => {					 
				console.log("signup response",response);

				if (!response.standardResponse.success) {
					// Alert.error(response.standardResponse.message, { timeout: 'none' });
					setAmsg(response.standardResponse.message);
					buttonRef.current.disabled = false;
					return;
				}


 
				saveAuthentication(response.accessToken);

				myUser.email = response.standardResponse.message;
				// const successMsg = " <h5> Please check " + myUser.email + " for verificatoin email to activate your account; <h5> "

				getCurrentUser()
					.then(res => {

						if (res != null) {
							saveUserInfo(res);
							console.log("res", res);
							props.modifyAccess({ authenticated: isAuthenticated(), user: userInfo(), aci: res.aci });


							// Alert.success(successMsg, {
							// 	timeout: 'none',
							// 	offset: 150,
							// 	html: true,
							// });

						}

						buttonRef.current.disabled = false;
					}).catch(error => {
						console.log("error:", error);

						if (buttonRef.current !== null)
							buttonRef.current.disabled = false;
					});



				// setSignupbtn(false);

				buttonRef.current.disabled = false;
				setAmsg(response.standardResponse.message);
				setVsent(false);


				// this.props.history.push("/login");
			}).catch(error => {

				console.log("error:", error);
				buttonRef.current.disabled = false;
			});


	}



	const displayRegistrationInfo = () => {

		return (
			<div>

				<form onSubmit={e => submitVerification(e)}>
                 <h6 className="text-left font-weight-bold text-success p-1">A verification Code has been sent to your phone {myUser.phone}</h6>
					<div className="form-item">
						<h5 className="text-left font-weight-bold">Verification Code:</h5>
						<input type="text" id="vcode"
							className="form-control" placeholder="Verification Code" minLength="4" 
							required />
					</div>

						<div className="form-item">
						<input type="text" id="firstName"
							className="form-control mt-2 mb-2" placeholder="First Name"
							required />
					</div>

					<div className="form-item">
						<input type="text" id="lastName"
							className="form-control mt-2 mb-2" placeholder="Last Name"
							required />
					</div>


					{/* <div className="form-item">
						<input type="email" id="email"
							className="form-control" placeholder="Email"
							required />
					</div> */}

					<div className="form-item mt-3">
							<h5 className="text-left font-weight-bold">Password:</h5>
						<input type="password" id="password" minLength="7" maxLength="50"
							className="form-control" placeholder="Password"
							required />
					</div>

						<button type="submit" ref={buttonRef} className="btn btn-success btn-sm btn-block mt-2 ml-5 mx-auto">Submit Verification</button>

				</form>

			</div>

		);

	}


	return (
		<div>

			<WarningAlert displayAlert={playalert} alertMessage={amsg} />
			<div>
				{vsent ? displayRegistrationInfo() : null}
				{vsent ? null : DisplayPhoneInput(cdc)}
				{vsent ? null : <button onClick={e => sendVerificationCode(e)} ref={buttonRefs} className="btn btn-success btn-sm btn-block mt-2 mb-2">Send Verification Code !</button>}
			</div>

		</div>

	);

}

export default PhoneSignupForm;